var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mx-3",attrs:{"id":"popup","color":"secondary","dismissible":"","prominent":"","dark":""}},[_vm._v("\n"+_vm._s(_vm.$t('installPWA'))),_c('img',{attrs:{"width":"25","height":"25","src":require("@/assets/ios-share-icon-15.jpg")}}),_vm._v(" "+_vm._s(_vm.$t('addToHomeScreen'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-169ca7d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InstallPWA.vue
// module id = 447
// module chunks = 1